import { useDispatch, useSelector } from 'react-redux';
import { addcouponToCart, addCouponToCartListSuccess, getcouponcartlist, getremoveCouponcartlist, removecouponCartListSuccess, setClippingProductId } from "redux/actions";
import { useGotoLogin } from 'hooks/useGotoLogin';
import { useApiDefaults } from './useApiDefaults';
import { getLocalStorageValue } from 'config/helper';
import axios from 'config/axios';
import { useGetCouponsCartDetails } from './useGetCouponsCartDetails';

export function useClipCouponDetails(_coupon) {
  const dispatch = useDispatch();
  const gotoLogin = useGotoLogin();

  let { selectedCoupon: coupon } = useSelector(({ cartCoupon }) => cartCoupon);
  coupon = _coupon ?? coupon;

  const apiDefaults = useApiDefaults();
  const userFirstName = getLocalStorageValue("first-name");
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { refetch: refetchCouponsCartDetails } = useGetCouponsCartDetails()

  const fetchCouponDetails = async (digital_coupon_id) => {
    const body = {
      RSAClientId: apiDefaults.RSAClientId,
      ClientStoreId: apiDefaults.ClientStoreId,
      offer_id: digital_coupon_id,
      user_token: apiDefaults.user_token,
    };
    
    const response = await axios.post('/AogGetCouponsDetails', body);
    return response?.data?.data || {}
  };

  const handleAddToCart = async (digital_coupon_id) => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    let couponDetails  = {...coupon}
    if (digital_coupon_id) {
      couponDetails = await fetchCouponDetails(digital_coupon_id)
    }

    const body = {
      ...apiDefaults,
      offer_id: couponDetails.offer_id,
      news_category_id: couponDetails.news_category_id,
      user_first_name: userFirstName,
      ncr_promotion_code: couponDetails.ncr_promotion_code,
      is_in_ncr_impressions: false,
      title: couponDetails.title,
      details: couponDetails.details,
      amount: couponDetails.amount || "1",
      product_name: couponDetails.product_name,
      real_valid_from: couponDetails.real_expires_on,
      real_expires_on: couponDetails.real_valid_from,
      upc: "",
    };

    dispatch(addcouponToCart(body)).then(() => {
      dispatch(addCouponToCartListSuccess(couponDetails))
      refetchCouponsCartDetails()
      dispatch(setClippingProductId(null))
    });
  };

  const handleRemoveCouponToCart = async (offer_id) => {
    const body = {
      ...apiDefaults,
      offer_id,
    };
    dispatch(getremoveCouponcartlist(body)).then(() => {
      refetchCouponsCartDetails()
      dispatch(removecouponCartListSuccess({offer_id}))
      dispatch(setClippingProductId(null))
    });
  };

  return {
    handleAddToCart,
    handleRemoveCouponToCart,
  }
}